import { Box, styled } from "@mui/material";

export const CircleBackground = styled(Box)({
  backgroundColor: "rgba(0,0,0,0.1)",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  lineHeight: "30px",
  textAlign: "center",
});
